export const FILE_NAME = 'receptacles_list';
export const PASS_FILE_NAME = 'pass_report';
export const TITLE = 'Receptacles List';
export const PASS_TITLE = 'PASS Report';
export const RECEPTACLE_ID_HEADER = 'Receptacle ID';
export const DESPATCH_ID_HEADER = 'Despatch ID';
export const CONSIGNMENT_ID_HEADER = 'Consignment ID';
export const PASS_BILLING_DATA_REPORT = 'BILLING_DATA';
export const PASS_RECONCILIATION_DATA_REPORT = 'RECONCILIATION_DATA';
export const FILE_FORMAT_EXCEL = 'EXCEL';
export const FILE_FORMAT_PDF = 'PDF';
export const FILE_FORMAT_CSV = 'CSV';

export const TABLE_COLUMNS = [
  {
    Header: RECEPTACLE_ID_HEADER,
    accessor: 'receptacleId',
    width: 275,
  },
  {
    Header: 'ALA achieved in ALA agreement',
    accessor: 'agreementAlaLevel',
    width: 123,
  },
  {
    Header: 'ALA achieved NOT in ALA agreement',
    accessor: 'alaLevel',
    width: 137,
  },
  {
    Header: 'Settlement Record Name',
    accessor: 'preSettlementName',
    width: 150,
  },
  {
    Header: 'Receptacle Settlement Status',
    accessor: 'settlementStatus',
    width: 110,
    type: '',
  },
  {
    Header: 'Mail Class',
    accessor: 'mailClass.label',
    width: 90,
  },
  {
    Header: 'Origin IMPC Code',
    accessor: 'originImpcCode',
    width: 130,
  },
  {
    Header: 'Dest IMPC Code',
    accessor: 'destImpcCode',
    width: 130,
  },
  {
    Header: 'Comments',
    accessor: 'comments',
    width: 130,
  },
  {
    Header: 'External Data Used',
    accessor: 'externalData',
    width: 90,
  },
  {
    Header: 'Invoice Number',
    accessor: 'invoiceNumber',
    width: 350,
  },
  {
    Header: 'Last Invoice Update',
    accessor: 'lastInvoiceUpdate',
    type: 'date',
    width: 130,
  },
  {
    Header: 'Invoice Creator',
    accessor: 'invoiceCreator',
    width: 130,
  },
  {
    Header: 'PARIS REF',
    accessor: 'receptacleReference',
    width: 225,
  },
  180,
];

export const TABLE_COLUMNS_EXTENDED = tableColumns => [
  ...tableColumns.slice(0, -1),
  {
    Header: 'Departure Airport',
    accessor: 'billingSectorFrom',
    width: 130,
  },
  {
    Header: 'Arrival Airport',
    accessor: 'billingSectorTo',
    width: 130,
  },
  {
    Header: 'Mail Category',
    accessor: 'mailCategory',
    width: 130,
  },
  {
    Header: 'Mail Subclass',
    accessor: 'mailSubClass',
    width: 130,
  },
  {
    Header: DESPATCH_ID_HEADER,
    accessor: 'despatchIdentifier',
    width: 200,
  },
  {
    Header: CONSIGNMENT_ID_HEADER,
    accessor: 'consignmentNr',
    width: 130,
  },
  {
    Header: 'Handling Class',
    accessor: 'handlingCode',
    width: 130,
  },
  {
    Header: 'Weight (kg)',
    accessor: 'weight',
    width: 130,
  },
  180,
];

export const PASS_COLUMNS = [
  {
    header: RECEPTACLE_ID_HEADER,
    key: 'receptacleId',
    width: 35,
  },
  {
    header: 'Carrier',
    key: 'carrier.label',
    width: 10,
  },
  {
    header: 'ALA achieved in ALA agreement',
    key: 'agreementAlaLevel',
    width: 13,
  },
  {
    header: 'ALA achieved NOT in ALA agreement',
    key: 'alaLevel',
    width: 13,
  },
  {
    header: 'Settlement Record Name',
    key: 'preSettlementName',
    width: 14,
  },
  {
    header: 'Receptacle Settlement Status',
    key: 'settlementStatus',
    width: 18,
  },
  {
    header: 'Mail Class',
    key: 'mailClass.label',
    width: 23,
  },
  {
    header: 'Postal Operator',
    key: 'operator.label',
    width: 10,
  },
  {
    header: 'Origin IMPC Code',
    key: 'originImpcCode',
    width: 18,
  },
  {
    header: 'Dest IMPC Code',
    key: 'destImpcCode',
    width: 30,
  },
  {
    header: 'Comments',
    key: 'comments',
    width: 15,
  },
  {
    header: 'External Data Used',
    key: 'externalData',
    width: 15,
  },
  {
    header: 'Invoice Number',
    key: 'invoiceNumber',
    width: 35,
  },
  {
    header: 'Last Invoice Update',
    key: 'lastInvoiceUpdate',
    width: 18,
  },
  {
    header: 'Invoice Creator',
    key: 'invoiceCreator',
    width: 18,
  },
  {
    header: 'PARIS REF',
    key: 'receptacleReference',
    width: 27,
  },
  {
    header: 'Departure Airport',
    key: 'billingSectorFrom',
    width: 18,
  },
  {
    header: 'Arrival Airport',
    key: 'billingSectorTo',
    width: 18,
  },
  {
    header: 'Mail Category',
    key: 'mailCategory',
    width: 15,
  },
  {
    header: 'Mail Subclass',
    key: 'mailSubClass',
    width: 15,
  },
  {
    header: DESPATCH_ID_HEADER,
    key: 'despatchIdentifier',
    width: 25,
  },
  {
    header: CONSIGNMENT_ID_HEADER,
    key: 'consignmentNr',
    width: 18,
  },
  {
    header: 'Handling Class',
    key: 'handlingCode',
    width: 18,
  },
  {
    header: 'Weight (kg)',
    key: 'weight',
    width: 18,
  },
];

export const HISTORY_TABLE_COLUMNS = [
  {
    Header: 'Action',
    accessor: 'actionType',
    width: 200,
  },
  {
    Header: 'User',
    accessor: 'executorName',
    width: 80,
  },
  {
    Header: 'Date (UTC)',
    accessor: 'creationDate',
    type: 'date',
    width: 100,
  },
  {
    Header: 'Comment',
    accessor: 'comment',
    width: 250,
  },
];
